"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACAccordion = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var react_1 = require("react");
var ACAccordion = function (props) {
    var name = props.name, _a = props.items, items = _a === void 0 ? [] : _a, _b = props.expandIconPosition, expandIconPosition = _b === void 0 ? 'start' : _b, _c = props.itemClassName, itemClassName = _c === void 0 ? '' : _c, _d = props.headerClassName, headerClassName = _d === void 0 ? '' : _d, _e = props.containerClassName, containerClassName = _e === void 0 ? '' : _e, _f = props.className, className = _f === void 0 ? '' : _f, renderFields = props.renderFields, value = props.value;
    var memoizedItems = (0, react_1.useMemo)(function () {
        if (!items)
            return [];
        return items.map(function (item) { return ({
            key: item === null || item === void 0 ? void 0 : item.key,
            label: item === null || item === void 0 ? void 0 : item.label,
            className: itemClassName,
            classNames: {
                header: headerClassName,
            },
            children: renderFields(item === null || item === void 0 ? void 0 : item.fields),
        }); });
    }, [items]);
    return ((0, jsx_runtime_1.jsx)("div", { className: containerClassName, children: (0, jsx_runtime_1.jsx)(antd_1.Collapse, { className: className, defaultActiveKey: value, ghost: props === null || props === void 0 ? void 0 : props.ghost, accordion: (props === null || props === void 0 ? void 0 : props.accordion) || false, expandIconPosition: expandIconPosition, items: memoizedItems }) }, name));
};
exports.ACAccordion = ACAccordion;
